<h1>Competencies You Saved for Later</h1>
<mat-card appearance="outlined" class="global sharp objective" >
  <mat-card-content>
    <p class="subtitle">View Details</p>
    <p class="highlighted">
      Any competencies you saved for later appear here. If you added learning activities or notes to the competencies, they also appear here. You can add these to your plan, remove the or leave them for consideration for future plan. If you want to add these to your plan, use the Edit Plan button.
    </p>
    <div class="item" *ngIf="savedCompetencies && savedCompetencies.length > 0" role="list">
      <mat-card appearance="outlined" class="body" *ngFor="let competency of savedCompetencies; let i = index" role="listitem">
        <mat-card-content>
          <p class="overline" *ngIf='competency.Domain !== "" && competency.Domain !== null && competency.Domain !== "Other"' [attr.aria-label]="competency.Domain + 'domain'"  aria-hidden="true">{{competency.Domain}} domain</p>
          <div class="obj-name-grid">
            <h2 class="competency" [id]="competency.Id" >{{competency.Name}}<span class="sr-only" *ngIf='competency.Domain !== "" && competency.Domain !== null && competency.Domain !== "Other"'>. Domain: {{competency.Domain}}</span></h2>
            <button mat-icon-button class="remove-btn" [attr.aria-label]="'Remove Competency'" [attr.aria-describedby]="competency.Id" (click)="deleteItem(competency)">
              REMOVE<span class="material-symbols-outlined">delete</span>
            </button>
          </div>
          <p class="notes-rating" *ngIf='competency.Rating !== "" && competency.Rating !== null'>
            <span class="notes-label">Proficiency Rating:</span>
            <span class="notes-body-strong"> {{competency.Rating}}</span>
          </p>
          <p class="notes-label" *ngIf="competency.Activities && competency.Activities.filter(checkActivity).length > 0">
            Learning Activities:
          </p>
          <div role="list">
            <p class="notes-body" role="listitem" *ngFor="let activity of competency.Activities.filter(checkActivity)">
              {{this.getActivityName(activity)}}
            </p>
          </div>
          <p class="notes-label" *ngIf='competency.ActivityNote !== "" && competency.ActivityNote !== null'>
            Learning Activity Notes:
          </p>
          <p class="notes-body">{{competency.ActivityNote}}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-card-content>
</mat-card>
